import React from 'react'
// libs
import { useQuery } from '@apollo/client/react'
// components
import { Button, BUTTON_LAYOUTS, CREATE_BUTTON_STYLE } from 'components/UI'
// constants
import { Modals } from 'constants/modals'
// hooks
import { useShowModal } from 'hooks/index'
// graphql
import { INJURY_MASTER_SETTINGS_QUERY } from 'graphql/injuryMaster/queries'
// types
import { IInjuryMasterSettings } from 'types/graphql'

const ConnectInjuryMaster: React.FC = () => {
  const { data } = useQuery<{ injuryMasterSettings: IInjuryMasterSettings }>(INJURY_MASTER_SETTINGS_QUERY)

  const settings = data?.injuryMasterSettings

  const { showModal } = useShowModal({ modalType: Modals.INJURY_MASTER_SETTINGS_MODAL })

  const onClick = () => showModal({ settings })

  return (
    <Button style={CREATE_BUTTON_STYLE} layout={BUTTON_LAYOUTS.PURPLE} onClick={onClick} disabled={!!settings}>
      Connect Injury Master
    </Button>
  )
}

export default ConnectInjuryMaster
